import {
  createAutomationTemplate as publicCreateAutomationTemplate,
  getAutomationTemplate as publicGetAutomationTemplate,
  updateAutomationTemplate as publicUpdateAutomationTemplate,
  deleteAutomationTemplate as publicDeleteAutomationTemplate,
  resolveAutomationTemplates as publicResolveAutomationTemplates,
  queryAutomationTemplatesForApp as publicQueryAutomationTemplatesForApp,
} from './automations-templates-v1-automation-template-automation-templates.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const createAutomationTemplate: MaybeContext<
  BuildRESTFunction<typeof publicCreateAutomationTemplate> &
    typeof publicCreateAutomationTemplate
> = /*#__PURE__*/ createRESTModule(publicCreateAutomationTemplate);
/** @internal */
export const getAutomationTemplate: MaybeContext<
  BuildRESTFunction<typeof publicGetAutomationTemplate> &
    typeof publicGetAutomationTemplate
> = /*#__PURE__*/ createRESTModule(publicGetAutomationTemplate);
/** @internal */
export const updateAutomationTemplate: MaybeContext<
  BuildRESTFunction<typeof publicUpdateAutomationTemplate> &
    typeof publicUpdateAutomationTemplate
> = /*#__PURE__*/ createRESTModule(publicUpdateAutomationTemplate);
/** @internal */
export const deleteAutomationTemplate: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAutomationTemplate> &
    typeof publicDeleteAutomationTemplate
> = /*#__PURE__*/ createRESTModule(publicDeleteAutomationTemplate);
/** @internal */
export const resolveAutomationTemplates: MaybeContext<
  BuildRESTFunction<typeof publicResolveAutomationTemplates> &
    typeof publicResolveAutomationTemplates
> = /*#__PURE__*/ createRESTModule(publicResolveAutomationTemplates);
/** @internal */
export const queryAutomationTemplatesForApp: MaybeContext<
  BuildRESTFunction<typeof publicQueryAutomationTemplatesForApp> &
    typeof publicQueryAutomationTemplatesForApp
> = /*#__PURE__*/ createRESTModule(publicQueryAutomationTemplatesForApp);

export {
  Category,
  Domain,
  TimeUnit,
  Operator,
  Language,
  Type,
  Status,
  Origin,
  CommonSortOrder,
  SortOrder,
  WebhookIdentityType,
} from './automations-templates-v1-automation-template-automation-templates.universal.js';
export {
  AutomationTemplate,
  Automation,
  AutomationOriginInfoOneOf,
  AIMetadata,
  ActionSettings,
  TriggerSettings,
  Enrichment,
  AuditInfo,
  AuditInfoIdOneOf,
  AutomationConfiguration,
  Filter,
  FutureDateActivationOffset,
  RateLimit,
  FilterValueSelection,
  ConditionExpressionGroup,
  CodeSnippet,
  Path,
  AppDefinedAction,
  ConditionAction,
  CodeConditionAction,
  DelayAction,
  RateLimitAction,
  SetVariablesAction,
  OutputAction,
  SplitAction,
  MergeAction,
  Trigger,
  Action,
  ActionInfoOneOf,
  FilterableAppDefinedActions,
  ApplicationOrigin,
  PreinstalledOrigin,
  TemplateOrigin,
  AutomationSettings,
  DraftInfo,
  Enrichments,
  ExtendedFields,
  AutoArchivePolicy,
  Notes,
  Note,
  Position,
  Offset,
  Dimensions,
  CategoryInfo,
  SegmentInfo,
  AutomationTemplateDeletedWithEntity,
  CreateAutomationTemplateRequest,
  AutomationTemplateSpecInfo,
  CreateAutomationTemplateResponse,
  GetAutomationTemplateRequest,
  GetAutomationTemplateResponse,
  UpdateAutomationTemplateRequest,
  UpdateAutomationTemplateResponse,
  DeleteAutomationTemplateRequest,
  DeleteAutomationTemplateResponse,
  ResolveAutomationTemplatesRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  CommonSorting,
  AddressLocation,
  Paging,
  CommonCursorPaging,
  ResolveAutomationTemplatesResponse,
  CommonCursorPagingMetadata,
  CommonCursors,
  QueryAutomationTemplatesForAppRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryAutomationTemplatesForAppResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateAutomationTemplateOptions,
  UpdateAutomationTemplate,
  UpdateAutomationTemplateOptions,
  QueryAutomationTemplatesForAppOptions,
} from './automations-templates-v1-automation-template-automation-templates.universal.js';
export {
  CategoryWithLiterals,
  DomainWithLiterals,
  TimeUnitWithLiterals,
  OperatorWithLiterals,
  LanguageWithLiterals,
  TypeWithLiterals,
  StatusWithLiterals,
  OriginWithLiterals,
  CommonSortOrderWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './automations-templates-v1-automation-template-automation-templates.universal.js';
